"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElementPieces = exports.moveElement = exports.mapData = exports.mapRowData = exports.checkIsUserData = exports.checkIsDataArrayOfNumbers = exports.getNewPosition = exports.getMiddleAngle = exports.createTopPath = exports.createStartWallPath = exports.createOuterPath = exports.createLabelPath = exports.getTextWidth = exports.createInnerPath = exports.createEndWallPath = void 0;
var const_1 = require("./const");
var createEndWallPath = function (endAngle, rx, ry, hight, ir) {
    var ex = rx * Math.cos(endAngle);
    var ey = ry * Math.sin(endAngle);
    return "M ".concat(ir * ex, " ").concat(ir * ey, " L ").concat(ir * ex, " ").concat(ir * ey + hight, " L ").concat(ex, " ").concat(ey + hight, " L ").concat(ex, " ").concat(ey, " z");
};
exports.createEndWallPath = createEndWallPath;
var createInnerPath = function (startAngle, endAngle, rx, ry, height, ir) {
    var innerStartAngle = (startAngle < const_1.pi ? const_1.pi : startAngle);
    var innerEndAngle = (endAngle < const_1.pi ? const_1.pi : endAngle);
    var sx = ir * rx * Math.cos(innerStartAngle);
    var sy = ir * ry * Math.sin(innerStartAngle);
    var ex = ir * rx * Math.cos(innerEndAngle);
    var ey = ir * ry * Math.sin(innerEndAngle);
    return "M ".concat(sx, " ").concat(sy, " A ").concat(ir * rx, " ").concat(ir * ry, " 0 0 1 ").concat(ex, " ").concat(ey, " L ").concat(ex, " ").concat(height + ey, " A ").concat(ir * rx, " ").concat(ir * ry, " ") +
        "0 0 0 ".concat(sx, " ").concat(height + sy, " z");
};
exports.createInnerPath = createInnerPath;
var isMiddleAngleRight = function (angle) {
    if (angle < const_1.pi / 2) {
        return true;
    }
    if (angle >= const_1.pi / 2 && angle <= 3 * const_1.pi / 2) {
        return false;
    }
    return true;
};
var getTextWidth = function (text, size) {
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    if (context !== null) {
        var font = window.getComputedStyle(document.body).font.split('px')[1];
        context.font = "".concat(size, "px").concat(font);
        return context.measureText(text).width;
    }
    return 0;
};
exports.getTextWidth = getTextWidth;
var createLabelPath = function (middleAngle, rx, ry, height, textLength, size) {
    var sx = rx * Math.cos(middleAngle);
    var sy = ry * Math.sin(middleAngle);
    var isLabelRight = isMiddleAngleRight(middleAngle);
    var distance = 20;
    return {
        path: "M ".concat(sx, " ").concat(sy + height / 2, " L ").concat(sx + (isLabelRight ? distance : -distance)) +
            " ".concat(sy + (middleAngle < const_1.pi ? distance + height / 2 : -distance), " l ").concat(isLabelRight ? distance : -distance, " 0"),
        x: sx + (isLabelRight ? distance : -distance) + (isLabelRight ? distance : -distance) +
            (isLabelRight ? 1 : -textLength - 1),
        y: sy + (middleAngle < const_1.pi ? distance + height / 2 : -distance) + size / 3.3
    };
};
exports.createLabelPath = createLabelPath;
var createOuterPath = function (startAngle, endAngle, rx, ry, hight) {
    var outerStartAngle = (startAngle > const_1.pi ? const_1.pi : startAngle);
    var outerEndAngle = (endAngle > const_1.pi ? const_1.pi : endAngle);
    var sx = rx * Math.cos(outerStartAngle);
    var sy = ry * Math.sin(outerStartAngle);
    var ex = rx * Math.cos(outerEndAngle);
    var ey = ry * Math.sin(outerEndAngle);
    return "M ".concat(sx, " ").concat(hight + sy, " A ").concat(rx, " ").concat(ry, " 0 0 1 ").concat(ex, " ").concat(hight + ey, " L ").concat(ex, " ").concat(ey, " A ").concat(rx, " ").concat(ry, " 0 0 0 ").concat(sx, " ").concat(sy, " z");
};
exports.createOuterPath = createOuterPath;
var createStartWallPath = function (startAngle, rx, ry, hight, ir) {
    var sx = rx * Math.cos(startAngle);
    var sy = ry * Math.sin(startAngle);
    return "M ".concat(ir * sx, " ").concat(ir * sy, " L ").concat(ir * sx, " ").concat(ir * sy + hight, " L ").concat(sx, " ").concat(sy + hight, " L ").concat(sx, " ").concat(sy, " z");
};
exports.createStartWallPath = createStartWallPath;
var createTopPath = function (startAngle, endAngle, rx, ry, ir) {
    if (endAngle - startAngle === 0) {
        return 'M 0 0';
    }
    var sx = rx * Math.cos(startAngle);
    var sy = ry * Math.sin(startAngle);
    var ex = rx * Math.cos(endAngle);
    var ey = ry * Math.sin(endAngle);
    return "M ".concat(sx, " ").concat(sy, " A ").concat(rx, " ").concat(ry, " 0 ").concat(endAngle - startAngle > const_1.pi ? 1 : 0, " 1 ").concat(ex, " ") +
        "".concat(ey, " L ").concat(ir * ex, " ").concat(ir * ey, " A ").concat(ir * rx, " ").concat(ir * ry, " 0 ").concat(endAngle - startAngle > const_1.pi ? 1 : 0) +
        "0 ".concat(ir * sx, " ").concat(ir * sy, " z");
};
exports.createTopPath = createTopPath;
var getMiddleAngle = function (startAngle, endAngle) {
    return startAngle + (endAngle - startAngle) / 2;
};
exports.getMiddleAngle = getMiddleAngle;
var getNewPosition = function (middleAngle, rx, ry, moveDistance) {
    return [
        moveDistance * rx * Math.cos(middleAngle > Math.PI ? middleAngle : -middleAngle),
        moveDistance * ry * Math.sin(middleAngle)
    ];
};
exports.getNewPosition = getNewPosition;
var checkIsDataArrayOfNumbers = function (data) {
    for (var i = 0; i < data.length; i++) {
        if (typeof data[i] !== 'number') {
            return false;
        }
    }
    return true;
};
exports.checkIsDataArrayOfNumbers = checkIsDataArrayOfNumbers;
var checkIsUserData = function (data) {
    for (var i = 0; i < data.length; i++) {
        if (data[i].value === undefined) {
            return false;
        }
    }
    return true;
};
exports.checkIsUserData = checkIsUserData;
var mapRowData = function (data) { return data.map(function (item) { return ({ value: item }); }); };
exports.mapRowData = mapRowData;
var mapData = function (data) {
    var sum = data.reduce(function (accumulator, item) {
        return typeof item === 'number' ? accumulator + item : accumulator + item.value;
    }, 0);
    return data.reduce(function (accumulator, item, index) {
        var _a;
        var angle = item.value / sum * 2 * const_1.pi;
        var previousValue = accumulator[index - 1];
        var startAngle = previousValue !== undefined ? previousValue.endAngle : 0;
        var endAngle = previousValue !== undefined ? previousValue.endAngle + angle : angle;
        var middleAngle = (0, exports.getMiddleAngle)(startAngle, endAngle);
        return __spreadArray(__spreadArray([], accumulator, true), [
            {
                color: (_a = item.color) !== null && _a !== void 0 ? _a : const_1.defaultColors[index % const_1.defaultColors.length],
                endAngle: endAngle,
                index: index,
                label: item.label,
                middleAngle: middleAngle,
                moved: false,
                percentageValue: item.value / sum,
                startAngle: startAngle,
                value: item.value
            }
        ], false);
    }, []);
};
exports.mapData = mapData;
var moveElement = function (startAngle, mappedData) { return mappedData.map(function (element) {
    return element.startAngle === startAngle ? __assign(__assign({}, element), { moved: !element.moved }) : element;
}); };
exports.moveElement = moveElement;
var createElementPieces = function (data) {
    var p1Elements = [];
    var p2Elements = [];
    var p3Elements = [];
    var p4Elements = [];
    var exceptionElements = [];
    for (var i = 0; i < data.length; i++) {
        if (data[i].endAngle < const_1.pi / 2) {
            p1Elements.push(data[i]);
        }
        else if (data[i].endAngle >= const_1.pi / 2 && data[i].endAngle <= const_1.pi) {
            p2Elements.push(data[i]);
        }
        else if (data[i].endAngle > const_1.pi && data[i].endAngle <= 3 / 2 * const_1.pi) {
            p3Elements.push(data[i]);
        }
        else if (data[i].startAngle > 3 / 2 * const_1.pi) {
            p4Elements.push(data[i]);
        }
        else if (data[i].endAngle > 3 / 2 * const_1.pi && data[i].startAngle <= 3 * const_1.pi / 2) {
            exceptionElements.push(data[i]);
        }
    }
    return [p1Elements, p2Elements, p3Elements, p4Elements, exceptionElements];
};
exports.createElementPieces = createElementPieces;
